var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.63833 3.88083C4.95996 3.79363 5.29176 3.74963 5.625 3.75H14.375C14.7167 3.75 15.0467 3.79583 15.3608 3.88083C15.1531 3.46582 14.8339 3.11683 14.439 2.87295C14.0441 2.62908 13.5891 2.49994 13.125 2.5H6.875C6.41074 2.49978 5.95559 2.62885 5.56054 2.87273C5.1655 3.11662 4.84617 3.46569 4.63833 3.88083ZM1.875 10C1.875 9.33696 2.13839 8.70107 2.60723 8.23223C3.07607 7.76339 3.71196 7.5 4.375 7.5H15.625C16.288 7.5 16.9239 7.76339 17.3928 8.23223C17.8616 8.70107 18.125 9.33696 18.125 10V15C18.125 15.663 17.8616 16.2989 17.3928 16.7678C16.9239 17.2366 16.288 17.5 15.625 17.5H4.375C3.71196 17.5 3.07607 17.2366 2.60723 16.7678C2.13839 16.2989 1.875 15.663 1.875 15V10ZM4.375 6.25C4.03333 6.25 3.70333 6.29583 3.38833 6.38083C3.59617 5.96569 3.9155 5.61662 4.31054 5.37273C4.70559 5.12885 5.16074 4.99978 5.625 5H14.375C14.8391 4.99994 15.2941 5.12908 15.689 5.37295C16.0839 5.61683 16.4031 5.96582 16.6108 6.38083C16.2895 6.2937 15.958 6.2497 15.625 6.25H4.375Z",
    fill: "#8A8A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget);
export default __webpack_public_path__ + "static/media/widget.b18d1ffb9da54bc887158087ade4f916.svg";
export { ForwardRef as ReactComponent };